import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconButton } from "@angular/material/button";
import { SvgComponent } from "app/shared/components/svg/svg-icon/svg-icon.component";
import { AccountSelectComponent } from "app/shared/components/account-select/account-select.component";
import { AccountService } from "app/core/services/account.service";
import { Account } from "app/shared/models/account";
import { Subject, takeUntil } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  imports: [MatIconButton, SvgComponent, AccountSelectComponent, CommonModule],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private isNavShownToggled: boolean = false;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @Output() public isNavShown: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  public selectedAccount: Account | null = null;

  constructor(
    private router: Router,
    private accountService: AccountService,
  ) {}

  public ngOnInit(): void {
    this.accountService.selectedAccount$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((account: Account | null) => {
        this.selectedAccount = account;
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Toggle for showing the nav-bar
   */
  public toggleNavShown(): void {
    this.isNavShown.emit(!this.isNavShownToggled);
  }

  private isSearchBarVisible(routerUrl: string): boolean {
    return !!this.selectedAccount && !routerUrl.includes("nconnect-voice");
  }
}
